module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "backmatter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "topictitle1",
    attrs: {
      "id": "ac67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/nav#nac67"
    }
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', [_vm._v("The author wishes to thank Michael Colleary and Mike Werb for their expert analysis and suggestions. For their enthusiasm\n            and support, he thanks Lawrence Bender, Caren Bohrman, Mike Dobson, and Janet Jeffries. Thanks also to Ann Howard Creel, Robb\n            McCaffree, and Robert Rodi for their careful reading of the manuscript. Special thanks to Dr. Edward O. Wilson, the Second\n            Darwin, for his magnificent contributions to science.\n         ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a2ab536","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Acknowledgments.vue
// module id = 66
// module chunks = 0